import * as React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { projectConfig } from "../../../../config/language/ja-JP/domain/model_text";
import { ConstColor } from "../../../../config/styles_const/styles_const";
import { Company } from "../../../../domain/model/company";
import { Contract } from "../../../../domain/model/contract";
import { Occupation, Project } from "../../../../domain/model/project";
import { User } from "../../../../domain/model/user";
import { entity } from "../../../../infra/api/rpc/api";
import ParagraphSup from "../../../common/atom/text/paragraph_sup";
import Paragraph from "../../atom/text/paragraph";

interface IProps {
  project: Project;
  company: Company;
  user: User | null;
  contract: Contract | null;
}

const ProjectCustomerCard: React.FC<IProps> = (props) => {
  const { project, company, user, contract } = props;

  const occupations: Occupation[] = project.occupations;
  const isOccupations: boolean = occupations.length !== 0;

  return (
    <Wrapper>
      <Link to={`/customer/project/${project.id}`}>
        <div>
          <ProjectThumbnailWrapper>
            <Img src={project.getThumbnailURL()} />
            <ProjectThumbnailBottomGradient />
            <ProjectThumbnailString>
              <ProjectThumbnailStringFlex>
                <ParagraphSupWhite>報酬/月</ParagraphSupWhite>
                <ParagraphWhite bold={true}>
                  {projectConfig.paymentRangeList[project.paymentRange]}
                </ParagraphWhite>
              </ProjectThumbnailStringFlex>
              <ProjectThumbnailStringFlex>
                <ParagraphSupWhite>時間/月</ParagraphSupWhite>
                <ParagraphWhite bold={true}>
                  {projectConfig.workingHourRangeList[project.workingHourRange]}
                </ParagraphWhite>
              </ProjectThumbnailStringFlex>
            </ProjectThumbnailString>
          </ProjectThumbnailWrapper>
          <ProjectInfoWrapper>
            <ProjectOccupationsWrapper>
              {isOccupations && (
                <ProjectOccupations>
                  {occupations.map((occupation) => {
                    return (
                      <OccupationBadge key={occupation}>
                        {projectConfig.occupationList.get(occupation)}
                      </OccupationBadge>
                    );
                  })}
                </ProjectOccupations>
              )}
            </ProjectOccupationsWrapper>
            <ProjectNameInner>
              <ProjectName bold={true}>{project.name}</ProjectName>
            </ProjectNameInner>
            <ProjectDescriptionInner>
              <ProjectDescription>{project.description}</ProjectDescription>
            </ProjectDescriptionInner>
          </ProjectInfoWrapper>
          <CompanyInfoWrapper>
            <CompanyName>{company.name}</CompanyName>
          </CompanyInfoWrapper>
        </div>
      </Link>
      {user != null && user!.customer != null && (
        <div>
          <Hr />
          <ActionButtons>
            {contract == null && (
              <ContractCreate>
                <Link
                  to={`/customer/contract/registration/${company.id}/${
                    project.id
                  }/${user!.customer!.id}`}
                >
                  <span style={{ color: "white" }}>成約報告</span>
                </Link>
              </ContractCreate>
            )}
            {contract != null &&
              contract.requester ===
                entity.Contract.Requester.Requester_Admin && (
                <ContractDisable>Adminから報告済</ContractDisable>
              )}
            {contract != null &&
              contract.requester ===
                entity.Contract.Requester.Requester_Customer && (
                <ContractDisable>成約報告済み</ContractDisable>
              )}
            {contract != null &&
              contract.requester ===
                entity.Contract.Requester.Requester_Company &&
              contract.isApproved && (
                <ContractDisable>承認済み</ContractDisable>
              )}
            {contract != null &&
              contract.requester ===
                entity.Contract.Requester.Requester_Company &&
              !contract.isApproved && (
                <ContractApprove>
                  <Link
                    to={`/customer/contract/${company.id}/${project.id}/${
                      user!.customer!.id
                    }`}
                  >
                    <span style={{ color: "white" }}>承認依頼</span>
                  </Link>
                </ContractApprove>
              )}
            <MessageLink>
              <Link
                to={`/customer/message/${project.id}/${user!.customer!.id}/${
                  company.id
                }`}
              >
                <span style={{ color: "white" }}>メッセージルーム</span>
              </Link>
            </MessageLink>
          </ActionButtons>
        </div>
      )}
    </Wrapper>
  );
};

export default ProjectCustomerCard;

const ActionButtons = styled.div`
  display: flex;
  align-items: center;
  padding: 12px;
`;

const ContractCreate = styled.div`
  flex: 1;
  padding: 5px 0px;
  background: #9a8c64;
  margin-right: 10px;
  border-radius: 3px;
  color: white;
  text-align: center;
  font-size: 12px;
`;

const ContractApprove = styled.div`
  flex: 1;
  padding: 5px 0px;
  background: #00d58e;
  margin-right: 10px;
  border-radius: 3px;
  color: white;
  text-align: center;
  font-size: 12px;
`;

const ContractDisable = styled.div`
  flex: 1;
  padding: 5px 0px;
  background: #a4a4a4;
  margin-right: 10px;
  border-radius: 3px;
  color: white;
  text-align: center;
  font-size: 12px;
`;

const MessageLink = styled.div`
  flex: 1;
  padding: 5px 0px;
  background: #9a8c64;
  margin-left: 10px;
  border-radius: 3px;
  color: white;
  text-align: center;
  font-size: 12px;
`;

const Wrapper = styled.div`
  width: 100%;
  box-shadow: 0px 0px 10px rgba(199, 199, 199, 0.2);
  border-radius: 10px;
  transition: all 0.3s ease;
  &:hover {
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.4);
  }
`;

const ProjectThumbnailWrapper = styled.div`
  position: relative;
`;

const ProjectDescriptionInner = styled.div`
  height: 54px;
`;

const ProjectNameInner = styled.div`
  height: 48px;
  margin-bottom: 10px;
`;

const ProjectThumbnailBottomGradient = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  height: 58px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
`;

const ProjectThumbnailString = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  margin-bottom: 10px;
  padding-right: 10px;
`;

const ProjectThumbnailStringFlex = styled.div`
  display: flex;
  align-items: center;
`;

const ParagraphSupWhite = styled(ParagraphSup)`
  color: ${ConstColor.White};
  margin-right: 10px;
`;

const ParagraphWhite = styled(Paragraph)`
  color: ${ConstColor.White};
`;

const ProjectOccupationsWrapper = styled.div`
  padding-bottom: 5px;
  height: 27px; // 仮
`;

const ProjectOccupations = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const OccupationBadge = styled.span`
  display: inline-block;
  padding: 3px 10px;
  margin-right: 5px;

  background: ${ConstColor.White};
  /* placeholder+Border */

  border: 1px solid ${ConstColor.PlaceholderAndBorder};
  border-radius: 21px;

  font-style: normal;
  font-weight: bold;
  font-size: 10px;
  line-height: 14px;

  color: ${ConstColor.Gray};
`;

const Img = styled.img`
  width: 100%;
  height: 130px;
  border-radius: 10px;
  object-fit: cover;
`;

const ProjectInfoWrapper = styled.div`
  padding: 20px;
`;

const ProjectName = styled(Paragraph)`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const ProjectDescription = styled(ParagraphSup)`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const Hr = styled.hr`
  height: 1px;
  margin: 0;
  background: ${ConstColor.PlaceholderAndBorder};
`;

const CompanyInfoWrapper = styled.div`
  padding: 10px 13px 16px;
`;

const CompanyName = styled(ParagraphSup)`
  text-align: right;
`;



// WEBPACK FOOTER //
// ./src/presentation/common/organism/card/project_customer_card.tsx